import { createContext } from "react";

const TaskPageContext = createContext({});

export default TaskPageContext;
